import { Component, OnInit } from '@angular/core';
import { initFlowbite } from 'flowbite';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/loader/loader.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, LoaderComponent],
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    // constructor() {}
    ngOnInit(): void {
        initFlowbite();
    }
}
